<template>
  <div class="add-danwei">
    <el-form ref="ruleForm" :model="viewData" :rules="rules" label-width="100px">
      <el-form-item label="小区" prop="commId">
        <el-cascader :options="options" :props="props" v-model="caasaderarr" collapse-tags clearable></el-cascader>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="viewData.title" />
      </el-form-item>
      <el-form-item label="图片（选填）">
        <image-upload ref="imageUpload"
                      :tipInfo="`上传图片格式为'jpg'、'jpeg'、'png'、'gif'，大小不超过2M，建议尺寸1920*1080；与视频二选一，上传视频时可不上传图片`"
                      :image-list="imageDefaultList" 
                      autoCropWidth="960"
                      autoCropHeight="540"
                      :maxNumber="1" 
                      @updateImg="onUpdateImg($event)"></image-upload>
      </el-form-item>
      <el-form-item label="视频（选填）">
        <upload-file ref="uploadFile"  tipInfo="上传视频格式为'MP4'，大小不超过50M，建议尺寸1920*1080；与图片二选一，上传图片时可不上传视频" :image-list="videoDefaultList" @updateImg="onUpdateVideo($event)"></upload-file>
        <!-- <image-video ref="ImageVideo"
            :tipInfo="`上传视频格式为'MP4'，大小不超过50M，建议尺寸1920*1080, 请自己处理好宽高比例`"
            :image-list="videoDefaultList" :maxNumber="1" @updateImg="onUpdateVideo($event)"></image-video> -->
      </el-form-item>
      <el-form-item label="生效时间">
        <el-date-picker v-model="viewData.publish_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="生效时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker v-model="viewData.end_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="跳转类型">
        <el-select v-model="viewData.tiaozhuantype" clearable filterable placeholder="请选择跳转类型">
          <el-option v-for="item in tiaozhuantypeList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="小程序AppID" v-if="viewData.tiaozhuantype==3">
        <el-input v-model="viewData.tiaozhuanappid" />
      </el-form-item>
      <el-form-item label="页面路径" v-if="viewData.tiaozhuantype!=1">
        <el-input v-model="viewData.tiaozhuanurl" />
      </el-form-item>
      <el-form-item label="跳转是否需要登录" v-if="viewData.tiaozhuantype==2||viewData.tiaozhuantype==3">
        <el-switch
          v-model="viewData.is_denglu"
          class="drawer-switch"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
      <el-form-item label="跳转是否需要业主" v-if="viewData.tiaozhuantype==2||viewData.tiaozhuantype==3">
        <el-switch
          v-model="viewData.is_yezhu"
          class="drawer-switch"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number size="mini" style="width: 100px" v-model="viewData.sort" controls-position="right"
                         :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="是否置顶">
        <el-switch v-model="viewData.is_top" class="drawer-switch" active-color="#13ce66"
                   inactive-color="#ff4949" :active-value="1" :inactive-value="0" />
      </el-form-item>
      <el-form-item label="发布状态">
        <el-switch v-model="viewData.status" class="drawer-switch" active-color="#13ce66"
                   inactive-color="#ff4949" :active-value="1" :inactive-value="0" />
      </el-form-item>
    </el-form>
    <div class="fix-fotter">
      <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;" size="mini"
                 type="primary" @click="tijiao('ruleForm')">提交</el-button>
    </div>
  </div>
</template>

<script>
  import UploadFile from "@/components/UploadVideo/bigVideo"
  // import ImageVideo from "@/components/UploadVideo/index";
  import ImageUpload from "@/components/Upload/image";
  import dylbanner from "@/api/tianzheng/dylbanner";
  import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
  export default {
    data() {
      return {
        thumbList: [],
        videoList:[],
        imageDefaultList: "",
        videoDefaultList:"",
        showUpload: false,
        optionCate: [],
        caasaderarr:[],
        optionList: [],
        tiaozhuantypeList:[{id:1,name:'不跳转'},{id:2,name:'跳转业主小程序'},{id:3,name:'跳转其他小程序'}],
        options: [],
        props: { multiple: true },
        viewData: {
          id: '',
          cate_id: '',
          title: "",
          video:"",
          thumb:"",
          caarr: [],
          tiaozhuantype:1,
          tiaozhuanappid: "",
          tiaozhuanurl:"",
          end_at:"",
          sort: 0,
          is_top: 0,
          status: 1,
          is_jituan: 0,
          publish_at: this.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
        },
        rules: {
          title: [
            {
              required: true,
              message: "请输入标题",
              trigger: "blur",
            },
          ],
        },
      };
    },
    components: {
      Pagination,
      ImageUpload,
      UploadFile
      // ImageVideo,
    },
    created() {
      this.getSelectCate()
    },
    methods: {
      onUpdateImg(val) {
        let thumbList = [];
        val.forEach((ele, idx) => {
          thumbList.push(ele.path);
        });
        this.thumbList = thumbList;
      },
      onUpdateVideo(val) {
        let videoList = [];
        val.forEach((ele, idx) => {
          videoList.push(ele.path);
        });
        this.videoList = videoList;
      },
      // 获取下拉列表
      getSelectCate() {
        dylbanner.select({}).then(res => {
          if (res.code == 200) {
            this.options = res.result;
            this.optionCate = res.result;
            // this.optionCate.unshift({
            //     id:-1,
            //     name:'请选择'
            // })
          }
        })
      },
      // 获取下拉列表
      // getSelectCity() {
      //     Qu.select({}).then(res => {
      //         if (res.code == 200) {
      //             this.optionList = res.result;
      //         }
      //     })
      // },
      /**
       * @name: 初始化列表
       * @param {*} obj
       * @return {*}
       * @desc:
       */
      initFun(obj) {
        this.resetForm()
        let that = this
        this.caasaderarr = [],
          this.viewData = {
            id: '',
            cate_id: '',
            caarr: [],
            title: "",
            video:"",
            thumb:"",
            tiaozhuantype:1,
            tiaozhuanappid: "",
            tiaozhuanurl:"",
            end_at:"",
            sort: 0,
            is_top: 0,
            status: 1,
            is_jituan: 0,
            publish_at: this.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
          }
        this.showUpload = true
        if (obj.id) {
          // 编辑
          this.viewData.id = obj.id;
          dylbanner.detail({ id: obj.id }).then((res) => {
            console.log(res)
            if (res.code == 200) {
              that.viewData = res.result
              that.viewData.id = res.result.id;
              that.caasaderarr = res.result.caarr
              if (that.viewData.thumb) {
                that.thumbList = [that.viewData.thumb];
                let imgList = [];
                let thumb_arr = [that.viewData.thumb];
                thumb_arr.forEach((ele, index) => {
                  let obj = {
                    name: ele,
                    path: ele,
                    url: that.$publicData.imgUrl + ele,
                  }
                  imgList.push(obj);
                })
                // 回显图
                that.imageDefaultList = JSON.stringify(imgList);
              } else {
                that.thumbList = [];
              }
              if (that.viewData.video) {
                that.videoList = [that.viewData.video];
                let imgList = [];
                let thumb_arr = [that.viewData.video];
                thumb_arr.forEach((ele, index) => {
                  let obj = {
                    name: ele,
                    path: ele,
                    url: that.$publicData.imgUrl + ele,
                  }
                  imgList.push(obj);
                })
                // 回显视频
                that.videoDefaultList = imgList;
              } else {
                that.videoList = [];
              }
            }
          });
        } else {
          // 新增
        }
      },
      /**
       * @name: 提交
       * @param {*} formName
       * @return {*}
       * @desc:
       */
      tijiao(formName) {
        let that = this
        const thumb = this.thumbList.length > 0 ? this.thumbList[0] : '';
        const video = this.videoList.length > 0 ? this.videoList[0] : '';
        if (!thumb && !video) {
          this.$message.warning("请上传图片或视频");
          return
        }
        this.viewData.thumb = thumb;
        this.viewData.video = video;
        this.viewData.caarr = this.caasaderarr;
        let count = 0
        for (let i = 0; i < this.options.length; i++) {
          const item = this.options[i];
          for (let j = 0; j < item.children.length; j++) {
            const subItem = item.children[j];
            for (let n = 0; n < subItem.children.length; n++) {
              count ++;
            }
          }
        }
        let is_jituan = 0
        if (this.caasaderarr.length >= count) {
          is_jituan = 1
        }
        if (this.viewData.end_at == null || this.viewData.end_at == undefined || this.viewData.end_at == "") {
          this.viewData.end_at = '2099-12-31 23:59:59'
        }
        this.viewData.is_jituan = is_jituan
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (that.viewData.id) {
              // 编辑
              dylbanner.edit(that.viewData).then(res => {
                if (res.code == 200) {
                  that.$message.success(res.message);
                  that.$emit('onUpdateDrawer', 1)
                } else {
                  // that.$message.error(res.message);
                  that.$emit('onUpdateDrawer', -1)
                }
              })
            } else {
              // 新增
              dylbanner.create(that.viewData).then(res => {
                if (res.code == 200) {
                  that.$message.success(res.message);
                  that.$emit('onUpdateDrawer', 1)
                } else {
                  // that.$message.error(res.message);
                  that.$emit('onUpdateDrawer', -1)
                }
              })
            }

          } else {
            this.$message.warning(this.$t('form.verifyMsg'))
          }
        })
      },
      /**
       * @name: 清空form
       * @return {*}
       * @desc:
       */
      resetForm() {
        this.thumbList = [];
        this.videoList = [];
        this.imageDefaultList = "";
        if (this.$refs.imageUpload) {
          this.$refs.imageUpload.clearFileList();
        }
        this.videoDefaultList = [];
        if (this.$refs.uploadFile) {
          this.$refs.uploadFile.clearFileList();
        }

        if (this.$refs["ruleForm"]) {
          this.$refs["ruleForm"].resetFields();
        }
        this.showUpload = false;
        this.viewData.publish_at = this.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
      },
      formatDate(tt, fmt) {
        if (null == tt || "" == tt) return "";
        var date = new Date(tt);
        let o = {
          "M+": date.getMonth() + 1, // 月份
          "d+": date.getDate(), // 日
          "h+": date.getHours(), // 小时
          "m+": date.getMinutes(), // 分
          "s+": date.getSeconds(), // 秒
          S: date.getMilliseconds() // 毫秒
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
